module.exports = __webpack_public_path__ + "static/media/lucas-bordeau.112cbe8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/lucas-bordeau.png
// module id = 1823
// module chunks = 0